import { parseJsonAttachment } from '@/feature-flags/utils/attachment-parser';
import { logInfo } from '@/feature-flags/utils/logger';

export function parseSwitchFlexToWhatsappCities(attachment: string | null | undefined): string[] {
  const parsed = parseJsonAttachment<unknown>(attachment, []);
  const cities = Array.isArray(parsed) ? parsed.filter((city): city is string => typeof city === 'string') : [];

  logInfo('Switch flex to whatsapp cities parsed', { cities });

  return cities;
}
